// src/contexts/UserTrackingContext.tsx
import React, { createContext, useContext } from 'react';

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

type TrackingEventData = {
  event_category: string;
  event_label: string;
  page_location: string;
};

type TrackingContextType = {
  trackEvent: (eventName: string, data: TrackingEventData) => void;
};

const UserTrackingContext = createContext<TrackingContextType | undefined>(undefined);

export const UserTrackingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const trackEvent = (eventName: string, data: TrackingEventData) => {
    const payload = {
      event: eventName,
      event_category: data.event_category,
      event_label: data.event_label,
      value: Date.now(), // current time in milliseconds
      page_location: data.page_location,
    };

    // console.log('[GTM Track]', payload);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };

  return (
    <UserTrackingContext.Provider value={{ trackEvent }}>
      {children}
    </UserTrackingContext.Provider>
  );
};

export const useUserTracking = () => {
  const context = useContext(UserTrackingContext);
  if (!context) throw new Error('useUserTracking must be used within a UserTrackingProvider');
  return context;
};
